import { useState, useEffect } from 'react';
import { getAdminTask } from '../../../api/admin/tasks';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { LOCATION_TASK_DEFAULT_RADIUS } from '../../../app.config.vars/stored';
import { setAdminTask } from '../../../store/adminSlices/rallies';
import { generateId } from '../../../helpers';
const useTaskFormState = ({ taskId, updated, setUpdated, }) => {
    const dispatch = useAppDispatch();
    const [titleTranslations, setTitleTranslations] = useState({ de: '', en: '', cs: '' });
    const [internalTitle, setInternalTitle] = useState('');
    const [selectedTaskType, setSelectedTaskType] = useState('info');
    const [descriptionTranslations, setDescriptionTranslations] = useState({
        de: '',
        en: '',
        cs: '',
    });
    const [fileReference, setFileReference] = useState(null);
    const [successPoints, setSuccessPoints] = useState(0);
    const [failurePoints, setFailurePoints] = useState(0);
    const [coordinatesLat, setCoordinatesLat] = useState(0);
    const [coordinatesLon, setCoordinatesLon] = useState(0);
    const [radius, setRadius] = useState(LOCATION_TASK_DEFAULT_RADIUS);
    const [taskStatus, setTaskStatus] = useState(0);
    const [taskAnswers, setTaskAnswers] = useState([
        {
            uid: null,
            translations: { de: '', en: '', cs: '' },
            isCorrect: false,
            sort: 1,
            clientId: generateId('answer'),
        },
        {
            uid: null,
            translations: { de: '', en: '', cs: '' },
            isCorrect: false,
            sort: 2,
            clientId: generateId('answer'),
        },
    ]);
    const [inputTaskAnswers, setInputTaskAnswers] = useState([
        {
            uid: null,
            translations: { de: '', en: '', cs: '' },
            clientId: generateId('input-answer'),
        },
    ]);
    const [isFormStateReady, setIsFormStateReady] = useState(!taskId);
    const [updatedFormFields, setUpdatedFormFields] = useState(() => new Set());
    const fetchData = async (taskId) => {
        setIsFormStateReady(false);
        try {
            const task = await getAdminTask(taskId);
            dispatch(setAdminTask(task));
            setTitleTranslations(task.title);
            setInternalTitle(task.internalTitle || '');
            setSelectedTaskType(task.taskType === 'information'
                ? 'info'
                : task.taskType === 'check-in'
                    ? 'location'
                    : task.answerType);
            setDescriptionTranslations(task.description);
            setFileReference(task.fileReference);
            setSuccessPoints(task.successPoints);
            setFailurePoints(task.failurePoints);
            setCoordinatesLat(task.coordinatesLat);
            setCoordinatesLon(task.coordinatesLon);
            setRadius(task.radius);
            setTaskStatus(task.status);
            if (task.answers.length) {
                if (task.taskType === 'action' && task.answerType === 'validated-text') {
                    setInputTaskAnswers(task.answers.map((answer) => ({
                        uid: answer.uid,
                        translations: answer.content,
                        clientId: generateId('input-answer'),
                    })));
                }
                else if (task.taskType === 'action' &&
                    (task.answerType === 'single-selection' || task.answerType === 'multiple-selection')) {
                    setTaskAnswers(task.answers.map((answer) => ({
                        uid: answer.uid,
                        translations: answer.content,
                        isCorrect: answer.isCorrect,
                        sort: answer.sort,
                        clientId: generateId('answer'),
                    })));
                }
            }
            setIsFormStateReady(true);
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    useEffect(() => {
        if (taskId) {
            fetchData(taskId);
        }
    }, []);
    useEffect(() => {
        if (taskId && updated) {
            fetchData(taskId);
            setUpdated(false);
        }
    }, [updated]);
    return {
        formState: {
            titleTranslations,
            setTitleTranslations,
            internalTitle,
            setInternalTitle,
            selectedTaskType,
            setSelectedTaskType,
            descriptionTranslations,
            setDescriptionTranslations,
            fileReference,
            setFileReference,
            successPoints,
            setSuccessPoints,
            failurePoints,
            setFailurePoints,
            coordinatesLat,
            setCoordinatesLat,
            coordinatesLon,
            setCoordinatesLon,
            radius,
            setRadius,
            taskStatus,
            setTaskStatus,
            taskAnswers,
            setTaskAnswers,
            inputTaskAnswers,
            setInputTaskAnswers,
        },
        updatedFormFields,
        setUpdatedFormFields,
        isFormStateReady,
    };
};
export default useTaskFormState;
